module.exports = __webpack_public_path__ + "static/media/08_strength.8b0d4050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/08_strength.png
// module id = 71
// module chunks = 0